// This file was auto-generated by Fern from our API Definition.
const V2EndpointLocationHttpMethodValues = {
    Get: "GET",
    Post: "POST",
    Put: "PUT",
    Patch: "PATCH",
    Delete: "DELETE",
    Head: "HEAD",
};
export const V2EndpointLocationHttpMethod = Object.assign(Object.assign({}, V2EndpointLocationHttpMethodValues), { _visit: (value, visitor) => {
        switch (value) {
            case V2EndpointLocationHttpMethod.Get:
                return visitor.get();
            case V2EndpointLocationHttpMethod.Post:
                return visitor.post();
            case V2EndpointLocationHttpMethod.Put:
                return visitor.put();
            case V2EndpointLocationHttpMethod.Patch:
                return visitor.patch();
            case V2EndpointLocationHttpMethod.Delete:
                return visitor.delete();
            case V2EndpointLocationHttpMethod.Head:
                return visitor.head();
            default:
                return visitor._other();
        }
    } });
